/**
 * Category list swiper wrapper class
 */
export class CategoriesComponent {

    constructor() {
        this.swiperClass = undefined;
        this.container = undefined;
        this.init();
    }

    init() {
        this.initSwiper();
    }

    /**
     * Initiate the swiper
     */
    initSwiper() {
        const swiperInstance = new Swiper(this.getSwiperClass(), {
            modules: [SwiperPagination],
            pagination: {
                el: '.swiper-pagination',
                dynamicBullets: true,
            },
            slidesPerView: 3,
            spaceBetween: '25px',
            breakpoints: {
                '992': {
                    slidesPerView: 4,
                    spaceBetween: '20px',
                },
                '1200': {
                    slidesPerView: 5,
                    spaceBetween: '40px',
                },
                '1540': {
                    slidesPerView: 6,
                    spaceBetween: '80px',
                },
            },
            init: false
        });

        swiperInstance.on('init', () => {
            this.getContainer().find(`${this.getSwiperClass()} img`).show();
        });

        swiperInstance.init();
    }

    /**
     * Returns the class of the swiper
     * @return {*}
     */
    getSwiperClass() {
        if (typeof this.swiperClass === 'undefined') {
            this.swiperClass = '.home-categories-swiper';
        }
        return this.swiperClass;
    }

    /**
     * Returns the container
     * @return {*}
     */
    getContainer() {
        if (typeof this.container === 'undefined') {
            this.container = $('#content-wrapper');
        }

        if (this.container.length === 0) {
            throw {element: this.container, reason: 'container not found!'};
        }
        return this.container;
    }
}
